<script setup lang="ts">
const { opened, contentRef } = await useInvitationPage();
const floatingButtonRef = useTemplateRef("floatingButton");

watch(
  () => opened.value,
  (val) => {
    if (val && import.meta.client) {
      document.documentElement.style.overflow = "";
      floatingButtonRef.value?.onToggleMusic();

      setTimeout(() => {
        contentRef.value?.focus();
      }, 500);
    }
  },
);
</script>

<template>
  <div>
    <LazyUiTransitionsInvitationCover>
      <POpeningCard
        v-if="!opened"
        @open="opened = true"
      />
    </LazyUiTransitionsInvitationCover>

    <NuxtLayout
      :opened="opened"
    >
      <LazyUiTransitionsInvitationMain>
        <div
          ref="contentRef"
          tabindex="-1"
          class="min-h-screen"
        >
          <LazyPHero
            :opened="opened"
          />

          <template
            v-if="opened"
          >
            <LazyVisiblePEvents
              hydrate-on-visible
            />
            <LazyVisiblePEventsCountdown
              hydrate-on-visible
            />
            <LazyVisiblePLocation
              hydrate-on-visible
            />
            <LazyVisiblePGallery
              hydrate-on-visible
            />
            <LazyVisiblePRsvp
              hydrate-on-visible
            />
            <LazyVisiblePGroupDcGift
              hydrate-on-visible
            />
            <LazyVisiblePWishes
              hydrate-on-visible
            />
          </template>

          <!-- Floating Buttons -->
          <div
            v-show="opened"
          >
            <LazyPFloatingButton
              ref="floatingButton"
              :opened="opened"
            />
          </div>
        </div>
      </LazyUiTransitionsInvitationMain>
    </NuxtLayout>
  </div>
</template>
